import { FC } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { ThemeProvider } from 'styled-components'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { persistor, store } from './redux'
import { Global, ROUTES, theme } from './utils'

import { AdminView, AuthView, HomeView, RoundView } from './views'
import { State } from './components'

const App: FC = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <Global/>
          <Router>
            {/* Routes here */}
            <Switch>
              <Route path={[ROUTES.auth.login, ROUTES.auth.register]} component={AuthView} exact/>
              <State>
                <Route path={ROUTES.home} component={HomeView} exact/>
                <Route path={ROUTES.round} component={RoundView} exact/>
                <Route path={ROUTES.admin.newHome} component={AdminView} exact/>
              </State>
            </Switch>
          </Router>
          <Toaster
            reverseOrder
            toastOptions={{
              position: 'bottom-center',
              style: {
                pointerEvents: 'none',
                background: theme.color.background,
                boxShadow: '0 1px 1px hsl(0deg 0% 0% / 0.015), 0 2px 2px hsl(0deg 0% 0% / 0.015), 0 4px 4px hsl(0deg 0% 0% / 0.015), 0 8px 8px hsl(0deg 0% 0% / 0.015), 0 16px 16px hsl(0deg 0% 0% / 0.015)',
                color: theme.color.gray[600],
                fontSize: 16
              }
            }}
          />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
